<button class="btn btn--icon" (click)="onDownloadClick()" *ngIf="!loading">
    <svg class="svg-icon svg-icon--s">
        <use href="assets/icons-ui.svg#downloaden"></use>
    </svg>
</button>

<button class="btn btn--icon disabled" *ngIf="loading">
    <svg class="svg-icon svg-icon--s">
        <use href="assets/icons-ui.svg#loading"></use>
    </svg>
</button>
